import { useEffect, useRef, Ref } from 'react';
import classNames from 'classnames';
import { Icon, useTranslation } from '@testsigma/atoms';

export const ActionItem = ({
  action,
  handleAction,
  isActiveItem,
  index,
  setHighlightedIndex,
  inputMethod,
  setInputMethod,
}) => {
  const ref: Ref<HTMLDivElement> = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (isActiveItem) {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [isActiveItem, ref]);

  return (
    <div
      className={classNames(
        'px-1.5 py-2 min-h-11 cursor-pointer rounded flex items-center hover:!bg-secondary-50/50',
        {
          '!bg-secondary-50': isActiveItem,
        },
      )}
      ref={ref}
      onClick={() => handleAction(action)}
      //   onMouseOver={() => {
      //     if (inputMethod === 'mouse') {
      //       setHighlightedIndex(index);
      //     }
      //   }}
      onMouseMove={() => setInputMethod('mouse')}
    >
      <div className='w-8 inline-flex items-center justify-center mr-2'>
        {action.icon && (
          <Icon
            className={classNames(
              '!text-secondary-500 text-xl',
              action.iconClass,
            )}
            name={action.icon}
          />
        )}
      </div>
      <div className='text-unique-600 font-normal text-sm'>
        {t(action.title)}
      </div>
    </div>
  );
};
